<script>
export default {
    props: {
        ticket: {
            type: Object,
            default: {}
        },
        type: {
            type: String,
            required: 'story',
        },
    },
    data() {
        return {
            open: true
        }
    },
}
</script>

<template>
  <div v-if="ticket.title" class="ticket"> <!-- todo: hack for poor initial data structure on epics tickets and stories array should be empty -->
    <div class="title">
      <div class="row">
          <div class="col-10">
            <h4><BaseIcon :name="type" source="svg"></BaseIcon>  {{ticket.title}}</h4>
          </div>
          <div class="col-2 text-right pr-4">
              <a class="toggle" @click="open = !open">
                  <div v-if="!open">
                      <BaseIcon name="panelClosed" source="svg"></BaseIcon>
                  </div>
                  <div v-if="open">
                      <BaseIcon name="panelOpen" source="svg"></BaseIcon>
                  </div>
              </a>
          </div>
        </div>
    </div>
    <div v-show="open" class="content pt-1 pb-1">
        <p v-html="ticket.description"></p>
    </div>
  </div>
</template>

<style  >
    .toggle div{
        cursor:pointer;
        margin: 10px 4px;
    }
  .ticket{
    background: #FFFFFF;
  }
  .title{
    border-bottom:3px solid #dbe8f2;
  }
  .title h4{
    font-family: Menlo-Bold;
    font-size: 12px;
    color: #404F61;
    letter-spacing: 0;
      margin-top:0px;
      margin-bottom:0px;
  }

  .epic p, .story p, .task p {
    font-family: Lato-Regular;
    font-size: 14px;
    color: #A7A8BB;
    letter-spacing: 0;
    line-height: 23px;
      margin-bottom:0px;
  }




</style>
